var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"admin",staticClass:"admin"},[_c('Headbar'),_c('Sidebar',{attrs:{"worknum":_vm.worknum_t,"meet_finish":_vm.meet_finish_t}}),_c('Container',[_c('router-view',{attrs:{"rez_num":_vm.rez_num_t}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }